import KineticHeading from "@/components/KineticHeading";
import Reveal from "@/components/Reveal";

const chapters = [
  ["01", "About", "Just a 25-year-old girl who loves writing romance books, hanging with my pup Rhino, and spending too much time watching TV.", "✍🏼"],
  ["02", "Location", "Living in sunny Hervey Bay, Queensland, Australia.", "📍"],
  ["03", "Favorites", "Favorite things include the colour green, the movie Never Been Kissed, the show Sabrina the Teenage Witch, and my love of pumpkin spice drinks!", "💚"],
  ["04", "Books", "The Summer I Turned Pretty by Jenny Han, Leaving Paradise by Simone Elkeles, Binding 13 by Chloe Walsh, and all the Windy City books.", "📚"],
];

const authorImage = "/about-bookshelf.webp";
const rhinoImage = "/about-rhino.webp";
const nightImage = "/about-night.webp";

export default function About() {
  return (
    <div className="px-5 pb-28 pt-36 md:px-8 md:pt-44" data-testid="about-page">
      <section className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <div>
            <Reveal><p className="text-xs uppercase tracking-[0.35em] text-cocoa/50" data-testid="about-eyebrow">The About Section</p></Reveal>
            <KineticHeading testId="about-kinetic-heading" lines={["A manifesto", "in pastel", "chapters."]} className="mt-6 font-display text-6xl font-light leading-[0.88] tracking-[-0.04em] md:text-8xl" />
          </div>
          <Reveal delay={0.25}>
            <p className="max-w-xl text-base leading-8 text-cocoa/65 md:text-lg" data-testid="about-intro-text">
              A little about myself, Morgan Ella. Just here sharing everything about me and my love for romance books.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto mt-24 grid max-w-7xl gap-8 lg:grid-cols-[0.8fr_1.2fr]" data-testid="about-manifesto-section">
        <Reveal className="lg:sticky lg:top-32 lg:self-start">
          <div className="relative grid gap-4 sm:grid-cols-2" data-testid="about-photo-trio">
            <div className="absolute -left-6 -top-6 h-40 w-40 rounded-full bg-petal" />
            <div className="arch-frame relative aspect-[4/5] overflow-hidden">
              <img src={authorImage} alt="Morgan reading beside shelves of fiction books" data-testid="about-author-image" className="h-full w-full object-cover object-center" />
            </div>
            <div className="relative sm:mt-16">
              <div className="absolute -right-5 -top-5 h-32 w-32 rounded-full bg-sky" />
              <div className="arch-frame relative aspect-[4/5] overflow-hidden">
                <img src={rhinoImage} alt="Morgan smiling with her dog Rhino" data-testid="about-rhino-image" className="h-full w-full object-cover object-center" />
              </div>
            </div>
            <div className="relative sm:col-span-2 sm:mx-auto sm:-mt-2 sm:w-3/4">
              <div className="absolute -bottom-5 -left-5 h-32 w-32 rounded-full bg-butter" />
              <div className="arch-frame relative aspect-[4/5] overflow-hidden">
                <img src={nightImage} alt="Morgan smiling outdoors at night" data-testid="about-night-image" className="h-full w-full object-cover object-center" />
              </div>
            </div>
          </div>
        </Reveal>
        <div className="space-y-8">
          {chapters.map(([number, title, text, emoji], index) => (
            <Reveal key={number} delay={index * 0.04}>
              <article className={`rounded-[2.5rem] border border-cocoa/10 p-8 md:p-12 ${index % 2 ? "ml-0 bg-sky/70 md:ml-20" : "mr-0 bg-white/75 md:mr-20"}`} data-testid={`manifesto-chapter-${number}`}>
                <p className="flex items-center gap-4 font-display text-7xl italic leading-none text-cocoa/15">
                  <span data-testid={`manifesto-number-${number}`}>{number}</span>
                  <span className="text-5xl not-italic text-cocoa" aria-hidden="true" data-testid={`manifesto-emoji-${number}`}>{emoji}</span>
                </p>
                <h2 className="mt-8 font-display text-4xl leading-tight md:text-5xl">{title}</h2>
                <p className="mt-6 max-w-2xl text-base leading-8 text-cocoa/65">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
